<!-- Старая (теоретически неиспользуемая) версия шаблона агенды -->


<template>
	<section class="row">
		<div class="agenda_set column" :class="{'showSetting':isShowSettings, 'hideSetting': !isShowSettings}">

			<h1 class="title_page">Расписание доктора</h1>

			<div id="datepicker"></div>
			<div class="daycounts">
				<span class="personal_items_wrap">Выберите количество дней

					<select title="select count of days" v-model="dayCount" @change="changeDayCount">
						<option value="1">1</option>
						<option value="3">3</option>
						<option value="5">5</option>
						<option value="7">7</option>
					</select>
				</span>
			</div>

			<div class="changer_width"></div>
			<div class="help_block"></div>

		</div>

		<div class="agenda_window column">
			<large-scheduler :clickDay="createVisit" :clickEvent="editVisit"
											 :isDoctor="doctorId == workerId()"></large-scheduler>
		</div>

	</section>
</template>

<script>
	import moment from 'moment'

	export default {
		name: 'Registry',
		computed: {
			doctorId() {
				return this.$route.query.doctor
			}
		},
		mounted () {
			this.$event.send('updateEvents', this.doctorId)
		},
		data() {
			return {
				day: '',
				dayCount: 5,
				isShowSettings: true
			}
		},
		methods: {
			createVisit(day, time, doctor) {
				this.$event.send('openEditModal', {
					begin: moment(day + ' ' + time, "DD-MM-YYYY HH:mm").format('X')
				}, doctor)
			},
			editVisit (event) {
				this.$event.send('openDetailsModal', event)
			},
			isset(roles, role) {
				return (roles.indexOf(role) !== -1)
			},
			goToAgenda(id) {
				this.$router.push({
					path: 'agenda',
					query: {
						doctor: id
					}
				})
			},
			workerId() {
				if (this.$storage.isExist('worker'))
					return this.$storage.get('worker')
			},
			changeDayCount() {
				this.$event.send('updateDayCount', this.dayCount)
			},
			onSelect(date) {
				this.$event.send('updateDayOfCalendar', date)
				this.day = date
			}
		}
	}
</script>

<style scoped>
	.agenda_set {
		transition: height 0.3s ease-out;
	}

	.showSetting {
		height: 470px;
		opacity: 1;
	}

	.hideSetting {
		height: 0;
		opacity: 0;
	}

	@media screen and (max-width: 700px) {
		.agenda_window.column {
			margin-top: 60px;
			height: 100%;
		}

		.details_modal {
			position: absolute;
			top: 100px;
		}
	}
</style>



// WEBPACK FOOTER //
// Agenda.vue?6ac223cd